import { render } from "./Commissions.vue?vue&type=template&id=444d3804&scoped=true"
import script from "./Commissions.vue?vue&type=script&lang=js"
export * from "./Commissions.vue?vue&type=script&lang=js"

import "./Commissions.vue?vue&type=style&index=0&id=444d3804&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekalifront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444d3804"]])

export default __exports__